import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';
import { useCustomRequestsModel } from 'features/creativeFunctionality/models';
import Spinner from 'components/Spinner/view/desktop';
import FilterBlock from './FilterBlock';
import CustomPageTable from './CustomPageTable/CustomPageTable';

import './CustomRequests.scss';

const b = block('custom-requests');

const CustomRequests = () => {
  const { actionProcessing } = useSelector(state => state.creativeFunctionality, shallowEqual);

  const model = useCustomRequestsModel();

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} foolViewport />
      <div className={b('filters')}>
        <FilterBlock model={model} />
      </div>
      <CustomPageTable model={model} />
    </div>
  );
};

export default CustomRequests;
